import { render, staticRenderFns } from "./MpAuthError.vue?vue&type=template&id=890a7fca&scoped=true"
import script from "./MpAuthError.vue?vue&type=script&lang=js"
export * from "./MpAuthError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890a7fca",
  null
  
)

export default component.exports